import StudentApplication from './StudentApplication';

export default StudentApplication;
